import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import "../../../common/common-css/CommonCss.css";
import Form_Header from "../../../common/form-header/Form_Header";
import Select from "react-select";
import "./Create_Step1.css";
import "react-phone-input-2/lib/style.css";
import { useRegistration } from "../../../../context/RegistrationContext";
import { registerGymOwner, submitStep1, getRegistrationProgress, getBusinessDesignation } from "../../../../utils/gymOwnerApi";
import Cookies from "js-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Create_Step1 = ({ step, totalSteps, setStep }) => {
  const { userId, saveUserId, setRegistrationData } = useRegistration();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [apiError, setApiError] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [show, setShow] = useState(false);
  const [showConfirm, setConfirmShow] = useState(false);


  const [designationOptions, setDesignationOptions] = useState([]);

  const { control, handleSubmit, register, formState: { errors }, setValue, watch } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      designation_id: null,
      mobile_number: "",
      email: "",
      password: "",
      address: "",
      dob: "",
    },
  });

  const apiDesignattions = async () => {
    const response = await getBusinessDesignation();
    if (response) {
      await setDesignationOptions(response);
    }
  }

  useEffect(() => {
    const loadProgress = async () => {
      if (userId) {
        setLoadingData(true);
        try {
          const response = await getRegistrationProgress();
          if (response.success && response.data) {
            const user = response.data.user;
            if (user) {
              setValue("first_name", user.first_name || "");
              setValue("last_name", user.last_name || "");
              setValue("designation_id", user.designation_id || null);
              setValue("mobile_number", user.mobile_number || "");
              setValue("email", user.email || "");
              setValue("address", user.address || "");
              setValue("dob", user.dob ? user.dob.split("T")[0] : "");
            }
            setRegistrationData(response.data);
          }
        } catch (error) {
          console.error("Error loading progress:", error);
        } finally {
          setLoadingData(false);
        }
      }
    };
    loadProgress();
    apiDesignattions();
  }, [userId, setValue, setRegistrationData]);

  const onSubmit = async (data) => {
    setLoading(true);
    setApiError("");

    const [year, month, day] = data.dob.split("-");
    // const formattedDob = `${parseInt(day)}/${parseInt(month)}/${year}`;
    const formattedDob = `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;

    try {
      if (!userId) {
        const registerData = {
          first_name: data.first_name,
          last_name: data.last_name,
          designation_id: data.designation_id?.value || data.designation_id,
          mobile_number: data.mobile_number?.replace(/\D/g, "") || data.mobile_number,
          email: data.email,
          password: data.password,
          password_confirmation: data.password_confirmation,

        };

        const registerResponse = await registerGymOwner(registerData);
        console.log({ registerResponse });

        if (registerResponse.success === false) {
          setApiError(registerResponse.message);
          return;
        }
        if (registerResponse.success && registerResponse.data?.user_id) {
          Cookies.set("gymify_web_security", registerResponse.data.token, {
            expires: 30,
            secure: true,
            sameSite: "strict",
          });

          saveUserId(registerResponse.data.user_id);
          const step1Data = {
            user_id: registerResponse.data.user_id,
            first_name: data.first_name,
            last_name: data.last_name,
            designation_id: data.designation_id?.value || data.designation_id,
            mobile_number: data.mobile_number?.replace(/\D/g, "") || data.mobile_number,
            email: data.email,
            address: data.address,
            dob: formattedDob,
            password: data.password,
            password_confirmation: data.password_confirmation,

          };
          const step1Response = await submitStep1(step1Data);
          if (step1Response.data.success === false) {
            setApiError(step1Response.data.message);
            return;
          } setStep(2);
        }
      } else {
        const step1Data = {
          user_id: userId,
          first_name: data.first_name,
          last_name: data.last_name,
          designation_id: data.designation_id?.value || data.designation_id,
          mobile_number: data.mobile_number?.replace(/\D/g, "") || data.mobile_number,
          email: data.email,
          address: data.address,
          dob: formattedDob,
          password: data.password,
          password_confirmation: data.password_confirmation,
        };
        const step1Response = await submitStep1(step1Data);
        if (step1Response.success === false) {
          setApiError(step1Response.message);
          return;
        } setStep(2);
      }
    } catch (error) {
      console.error("Error submitting step 1:", error);
      setApiError("Something went wrong. Please try again.");

    } finally {
      setLoading(false);
    }
  };
  return (
    <section className="step1_wrapper">
      <Form_Header
        title="Authorized Signatory Details (KYC)"
        subtitle=""
        step={1}
        totalSteps={7}
      />

      <div className="container">
        {loadingData ? (
          <div className="text-center py-5">
            <p>Loading saved data...</p>
          </div>
        ) : (
          <Form className="auth_form" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>First Name *</Form.Label>
                  <Controller
                    name="first_name"
                    control={control}
                    rules={{ required: "First name is required" }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter First Name"
                        {...field}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.first_name?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Last Name *</Form.Label>
                  <Controller
                    name="last_name"
                    control={control}
                    rules={{ required: "Last name is required" }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter Last Name"
                        {...field}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.last_name?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Designation in Business *</Form.Label>
                  <Controller
                    name="designation_id"
                    control={control}
                    rules={{ required: "Designation is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={designationOptions}
                        placeholder="Select designation"
                        className="react-select-container"
                        classNamePrefix="react-select"
                        value={designationOptions.find(
                          (opt) => opt.value === field.value
                        )}
                        onChange={(selected) => field.onChange(selected)}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.designation_id?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6 mb-4">
                <Form.Group className="mb-3">
                  <Form.Label>Contact *</Form.Label>
                  <Controller
                    name="mobile_number"
                    control={control}
                    rules={{ required: "Contact number is required" }}
                    render={({ field }) => (
                      <PhoneInput
                        country="in"
                        value={field.value}
                        onChange={field.onChange}
                        enableSearch
                        specialLabel=""
                        countryCodeEditable={true}
                        inputClass="phone_input"
                        containerClass="phone_container"
                        buttonClass="phone_flag_btn"
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.mobile_number?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Date of Birth *</Form.Label>
                  <Form.Control
                    type="date"
                    max={new Date().toISOString().split("T")[0]}
                    isInvalid={!!errors.dob}
                    {...register("dob", {
                      required: "Date of birth is required",
                      validate: {
                        notFuture: (value) => {
                          const today = new Date();
                          const dob = new Date(value);
                          return dob < today || "Date of birth cannot be a future date";
                        },
                        minAge: (value) => {
                          const today = new Date();
                          const dob = new Date(value);
                          const age = today.getFullYear() - dob.getFullYear();
                          const monthDiff = today.getMonth() - dob.getMonth();
                          const actualAge =
                            monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())
                              ? age - 1
                              : age;
                          return actualAge >= 14 || "You must be at least 14 years old";
                        },
                        maxAge: (value) => {
                          const today = new Date();
                          const dob = new Date(value);
                          const age = today.getFullYear() - dob.getFullYear();
                          return age <= 100 || "Please enter a valid date of birth";
                        },
                      },
                    })}
                  />
                  <div className="text-danger">
                    {errors.dob?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6 mb-4">
                <Form.Group className="mb-4">
                  <Form.Label>Personal Email Id *</Form.Label>
                  <Controller
                    name="email"
                    control={control}
                    rules={{
                      required: "Email is required",
                      pattern: {
                        value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                        message: "Enter a valid email address",
                      },
                    }}
                    render={({ field }) => (
                      <Form.Control
                        type="email"
                        placeholder="Enter Email"
                        {...field}
                      />
                    )}
                  />
                  <div className="text-danger">
                    {errors.email?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Password *</Form.Label>
                  <Controller
                    name="password"
                    control={control}
                    rules={{
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Password must be at least 6 characters",
                      },
                    }}

                    render={({ field }) => (
                      <div className="password-wrapper">
                        <Form.Control
                          type={show ? "text" : "password"}
                          placeholder="Enter Password"
                          {...field}
                        />

                        <span className="eye-icon" onClick={() => setShow(!show)}>
                          <FontAwesomeIcon icon={show ? faEye : faEyeSlash} />
                        </span>
                      </div>
                    )}
                  />
                  {/* <div
                    className="eye_icons_holder"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                  </div>
                  <div className="text-danger">
                    {errors.password?.message}
                  </div> */}
                </Form.Group>
              </div>

              <div className="col-lg-6 mb-4">
                <Form.Group>
                  <Form.Label>Re-Enter Password *</Form.Label>
                  <Controller
                    name="password_confirmation"
                    control={control}
                    rules={{
                      required: "Please confirm password",
                      validate: (value) =>
                        value === watch("password") ||
                        "Passwords do not match",
                    }}
                    render={({ field }) => (
                      <div className="password-wrapper">
                        <Form.Control
                          type={showConfirm ? "text" : "password"}
                          placeholder="Confirm Password"
                          {...field}
                        />

                        <span
                          className="eye-icon"
                          onClick={() => setConfirmShow(!showConfirm)}
                        >
                          <FontAwesomeIcon icon={showConfirm ? faEye : faEyeSlash} />
                        </span>
                      </div>
                    )}
                  />
                  <div
                    className="eye_icons_holder"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    style={{ cursor: "pointer" }}
                  >
                    <FontAwesomeIcon icon={showConfirmPassword ? faEye : faEyeSlash} />
                  </div>
                  <div className="text-danger">
                    {errors.password_confirmation?.message}
                  </div>
                </Form.Group>
              </div>

              <div className="col-lg-12 mb-4">
                <Form.Group>
                  <Form.Label>Residential Address *</Form.Label>
                  <Controller
                    name="address"
                    control={control}
                    rules={{ required: "Address is required" }}
                    render={({ field }) => (
                      <Form.Control
                        type="text"
                        placeholder="Enter Residential Address"
                        {...field}
                      />
                    )}
                  />

                  <div className="text-danger">
                    {errors.address?.message}
                  </div>
                </Form.Group>
              </div>

              {apiError && (
                <div className="alert alert-danger w-100 mb-3">{apiError}</div>
              )}

              <div className="form_btn_holder">


                <Common_Btn
                  btnText={loading ? "Submitting..." : "Next"}
                  type="submit"
                  disabled={loading}
                />
              </div>
            </div>
          </Form>
        )
        }
      </div >
    </section >
  );
};

export default Create_Step1;
